import Common from '../../../Common';

export interface CompanyPbxDadDid {
	id: id
	e164: string
	number: string
}

const Did = class extends Common {
	browse = (companyId: id): CustomResponse<CompanyPbxDadDid[]> =>
		this.get(`/company/${companyId}/pbxdad/did`)
}

export default Did
